import { AfterViewInit, DestroyRef, Directive } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appEmptyToNull]',
    standalone: false
})
export class NullValueDirective implements AfterViewInit {
  constructor(
    private ngControl: NgControl,
    private destroyRef: DestroyRef) { }

  ngAfterViewInit(): void {
    this.ngControl.valueChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: string) => {
      if (value === '' || value === undefined) {
        this.ngControl.control?.setValue(null, { emitEvent: false });
      }
    });
  }
}
